import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generarPDF = async (html, nombreArchivo = 'documento.pdf', ancho = 80) => {
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.width = '300px';
    tempContainer.innerHTML = html;
    document.body.appendChild(tempContainer);

    try {
      const canvas = await html2canvas(tempContainer, { scale: 2, useCORS: true });
      const jpegData = canvas.toDataURL('image/jpeg', 1.0);
      const scaleFactor = ancho / canvas.width;
      const alto = canvas.height * scaleFactor;

      const pdf = new jsPDF('p', 'mm', [ancho, alto]);
      pdf.addImage(jpegData, 'JPEG', 0, 0, ancho, alto);
      pdf.save(nombreArchivo);
    } catch (error) {
      console.error("Error al generar PDF:", error);
    } finally {
      document.body.removeChild(tempContainer);
    }
  };
